module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-links-5735520f71b486f4eac6479ea09cf889.svg";